import { useQuery } from "react-query";

import { fetchOrganizationUsers, getDeploymentUsers } from "@api";
import { useOrg } from "@hooks/useOrg";
import { OrgData } from "@types";

export const useDeploymentMembers = (org: OrgData) => {
  return useQuery(
    ["deploymentMembers", { org }],
    () => getDeploymentUsers(org?.id!),
    {
      enabled: !!org,
      keepPreviousData: true,
    }
  );
};

export const useOrganizationMembers = (org: OrgData) => {
  return useQuery(
    ["organizationMembers", { org }],
    () => fetchOrganizationUsers(org?.organization_id!),
    {
      enabled: !!org && !!org.organization_id,
      keepPreviousData: true,
    }
  );
};

export const useMembers = () => {
  const org = useOrg();

  const deploymentMembers = useDeploymentMembers(org!);
  const deploymentMembersOpt = deploymentMembers?.data || [];
  const deploymentMembersIds = deploymentMembersOpt.map((user) => user.id);

  const organizationMembers = useOrganizationMembers(org!);
  const organizationMembersOpt = (organizationMembers?.data || []).filter(
    (user) => !deploymentMembersIds.includes(user.id)
  );

  const allMembers = [...deploymentMembersOpt, ...organizationMembersOpt];

  return useQuery(["members", { org }], () => [...new Set(allMembers)], {
    enabled: !!org && !!deploymentMembers.data && !!organizationMembers.data,
    keepPreviousData: true,
  });
};
